import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
  AddSocietieAction,
  DeleteSocietieAction,
  GetAllSocietiesAction,
  UpdatedSocietieAction,
} from './societies.actions';
import { ISociedad } from '../../core/interfaces/societies.interface';
import { HttpService } from '../../core/services/http/http.service';
import { EnovaAlertsComponent } from '../../core/utils/enova-alerts/enova-alerts.component';
import { MatDialog } from '@angular/material/dialog';

export interface SocietiesStateModel {
  societies: ISociedad[];
}

@State<SocietiesStateModel>({
  name: 'Societies',
  defaults: {
    societies: [],
  },
})
@Injectable()
export class SocietiesState {
  @Selector() static GetAllData(state: SocietiesStateModel): ISociedad[] {
    return state?.societies ?? [];
  }

  constructor(
    private httpService: HttpService,
    public dialog: MatDialog
  ) {}

  @Action(GetAllSocietiesAction)
  async GetAllSocietiesAction(ctx: StateContext<SocietiesStateModel>) {
    try {
      const resp = await this.httpService.getSocieties();
      if (resp && resp.length) {
        ctx.patchState({
          societies: resp,
        });
      }
    } catch (error) {
      this.dialog.open(EnovaAlertsComponent, {
        width: 'auto',
        data: {
          type: 'error',
          hiddeCancelBtn: true,
        },
      });
    }
  }

  @Action(AddSocietieAction)
  async AddSocietieAction(
    ctx: StateContext<SocietiesStateModel>,
    { payload }: AddSocietieAction
  ) {
    return this.httpService
      .postSocietie(payload)
      .then(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'success',
            text: '¡La sociedad se ha creado de forma exitosa!',
            hiddeCancelBtn: true,
          },
        });
        ctx.dispatch(new GetAllSocietiesAction());
      })
      .catch(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'error',
            hiddeCancelBtn: true,
          },
        });
      });
  }

  @Action(UpdatedSocietieAction)
  async UpdatedSocietieAction(
    ctx: StateContext<SocietiesStateModel>,
    { payload }: UpdatedSocietieAction
  ) {
    return this.httpService
      .updateSocietie(payload)
      .then(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'success',
            text: '¡La sociedad se ha actualizado de forma exitosa!',
            hiddeCancelBtn: true,
          },
        });
        ctx.dispatch(new GetAllSocietiesAction());
      })
      .catch(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'error',
            hiddeCancelBtn: true,
          },
        });
      });
  }

  @Action(DeleteSocietieAction)
  async DeleteSocietieAction(
    ctx: StateContext<SocietiesStateModel>,
    { payload }: DeleteSocietieAction
  ) {
    return this.httpService
      .deleteSocietie(payload)
      .then(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'success',
            text: '¡La sociedad se ha eliminado de forma exitosa!',
            hiddeCancelBtn: true,
          },
        });
        ctx.dispatch(new GetAllSocietiesAction());
      })
      .catch(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'error',
            hiddeCancelBtn: true,
          },
        });
      });
  }
}
